import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Checkbox,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  useToast,
} from "alm-react-components";
import { updatePassword } from "aws-amplify/auth";
import { useContext, useEffect, useLayoutEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { ActionType, StatusCode } from "../../../assets/constants/constants";
import { analytics_category, analytics_event, analytics_label } from '../../../assets/constants/staticContentConstants';
import eye from "../../../assets/images/eye.svg";
import eyeslash from "../../../assets/images/eyeslash.svg";
import { AppContext } from "../../../context/AppProvider";
 import useGaEventTracking from '../../../hooks/UseGaEventTracking';
import useSubscription from "../../../hooks/useSubscription";
import { clearLocalStorage, encrptText, removeChainlitPopup } from "../../../lib/utils";
import { deviceDetails } from "../../../services/user";
import withAlmToken from "../../common/withAlmToken";
import useAlmCorporateStatus from "../../../hooks/useAlmCorporateStatus";
type Inputs = {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
  mobile: boolean;
};

const UpdatePassword = () => {
  const [error, setError] = useState("");
  const [codeError, setCodeError] = useState("");
  const [revealed, setRevealed] = useState(false);
  const [currentPassword, setCurrentPassword] = useState(false);
  const [confrimPassword, setConfirmPassword] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { callSubscription } = useSubscription();
  const { state, dispatch } = useContext(AppContext);
  useAlmCorporateStatus();
 
  const location = useLocation();
  const from: any = location?.state?.from;

  const gaEventTracker = useGaEventTracking();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }, []);
  
  useEffect(() => {
      if(state.user){
        if(!state.user?.corporateAccountId)
          callSubscription("valid");
      }
  }, [state.user]);
  async function onhandleSubmitCode(values: Inputs) {
    dispatch({ type: ActionType.SET_LOADING, payload: true });
    updatePassword({
      oldPassword: encrptText(values.currentPassword),
      newPassword: encrptText(values.confirmNewPassword),
    })
      .then(() => {
        if (values.mobile) {
          
          deviceDetails()
            .then((res: any) => {
              if (res.status === StatusCode.SUCCESS) {
                // Remove chainit popup
                removeChainlitPopup();
                clearLocalStorage();
                navigate("/");
              }
            })
            .catch((error) => {
              console.log("error", error);
            });
        } else {
          toast({
            description: t("Common.msgPasswordUpdated"),
            variant: "success",
          });
          setTimeout(() => {
            removeChainlitPopup();
            navigate("/home");
          }, 1000);
          const items = {
            value: null,
            currency: null,
            transaction_id: null,
            items: [{}],
            userId:state.user?.userId
        };      
      gaEventTracker(analytics_event.changePassword,analytics_category.buttonCliCkChangePassword,analytics_label.ChangePasswordLable,items);
        }
        dispatch({ type: ActionType.SET_LOADING, payload: false });
      })
      .catch((error) => {
        if (error.name == "UserNotFoundException") {
          setError(t("Validations.userNotFoundError"));
        } else if (error.name == "ExpiredCodeException") {
          setCodeError(t("Validations.codeExpiredError"));
        } else if (error.name == "CodeMismatchException") {
          setCodeError(t("Validations.invalidVerification"));
        } else if (error.name == "LimitExceededException") {
          setCodeError(t("Validations.attemptLimitError"));
        } else if (error.name == "NotAuthorizedException") {
          setCodeError(t("Validations.emptyPasswordField"));
          toast({
            description: t("Validations.emptyPasswordField"),
            variant: "error",
          });
        } else {
          setError(error.name);
        }
        dispatch({ type: ActionType.SET_LOADING, payload: false });
      });
  }

  const schema2 = yup.object({
    currentPassword: yup
      .string()
      .required(t("Validations.currentPasswordRequired")),

    newPassword: yup
      .string()
      .required(t("Validations.newPasswordRequired"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
        t("Validations.msgPasswordValidation")
      ),

    confirmNewPassword: yup
      .string()
      .required(t("Validations.confirmPasswordRequired"))
      .oneOf([yup.ref("newPassword")], t("Validations.passwordNotMatch"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/,
        t("Validations.msgPasswordValidation")
      ),
    mobile: yup.boolean().required(),
  });
  const form2 = useForm<Inputs>({
    resolver: yupResolver(schema2),
    mode: "onChange",
    defaultValues: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      mobile: false,
    },
  });
  const handleChange = () => {
    if (form2.getValues("confirmNewPassword")) {
      form2.trigger("confirmNewPassword");
    }
  };

  const backFromDailyReminder =()=>{
    if(from){
      navigate(from)
    }else{
      removeChainlitPopup()
      navigate(-1)
    }
  }
  return (
 
      <div className=" md:min-w-[486px] md:max-w-[486px] px-4 py-16 mx-auto">
        <div className="flex flex-col gap-6">
          <p
            className="flex text-4xl justify-center font-barlowLight"
            dangerouslySetInnerHTML={{
              __html: t("UpdatePassword.changePassword"),
            }}
          />
          <p
            className="text-base"
            dangerouslySetInnerHTML={{
              __html: t("UpdatePassword.changePasswordText"),
            }}
          />
        </div>

        <Form {...form2}>
          <form
            onSubmit={form2.handleSubmit(onhandleSubmitCode)}
            onChange={handleChange}
            className=""
          >
            <div className="grid w-full items-center gap-4 mb-6 mt-6">
              <div className="flex flex-col space-y-1.5 text-base">
                <FormField
                  control={form2.control}
                  name="currentPassword"
                  render={({ field }) => (
                    <FormItem className="relative">
                      <FormLabel
                        className="text-xs tracking-wider"
                        dangerouslySetInnerHTML={{
                          __html: t("UpdatePassword.currentPassword") + " *",
                        }}
                      />

                      <FormControl>
                        <Input
                          placeholder={t("UpdatePassword.currentPlaceholder")}
                          {...field}
                          className="h-auto py-4 text-base pe-16 opacity-100"
                          type={currentPassword ? "text" : "password"}
                        />
                      </FormControl>
                      {currentPassword ? (
                          <img
                            className="absolute top-[45px] right-[16px] w-[26px] h-[16px]"
                            onClick={() => setCurrentPassword(!currentPassword)}
                            src={eye}
                            alt="No image"
                          />
                      ) : (
                          <img
                            className="absolute top-[41px] right-[15px] w-[29px] h-[22px]"
                            onClick={() => setCurrentPassword(!currentPassword)}
                            src={eyeslash}
                            alt="No image"
                          />
                      )}
                      <FormMessage>{codeError}</FormMessage>
                    </FormItem>
                  )}
                />
              </div>
              <p
                onClick={() =>{
                   removeChainlitPopup()
                   navigate("/reset-password")
                  }}
                className="flex flex-row justify-start underline text-sm cursor-pointer text-primary"
                dangerouslySetInnerHTML={{
                  __html: t("UpdatePassword.forgotPassword"),
                }}
              ></p>
            </div>
            <div className="grid w-full items-center gap-4 mb-6">
              <div className="flex flex-col space-y-1.5 text-base">
                <FormField
                  control={form2.control}
                  name="newPassword"
                  render={({ field }) => (
                    <FormItem className="relative">
                      <FormLabel
                        className="text-xs tracking-wider"
                        dangerouslySetInnerHTML={{
                          __html: t("UpdatePassword.newPassword") + " *",
                        }}
                      />

                      <FormControl>
                        <Input
                          type={revealed ? "text" : "password"}
                          placeholder={t("UpdatePassword.newPlaceHolder")}
                          {...field}
                          className="h-auto py-4 text-base pe-16 opacity-100"
                        />
                      </FormControl>
                      {revealed ? (
                          <img
                            className="absolute top-[45px] right-[16px] w-[26px] h-[16px]"
                            onClick={() => setRevealed(!revealed)}
                            src={eye}
                            alt="No image"
                          />
                      ) : (
                          <img
                            className="absolute top-[41px] right-[15px] w-[29px] h-[22px]"
                            onClick={() => setRevealed(!revealed)}
                            src={eyeslash}
                            alt="No image"
                          />
                      )}
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <div className="grid w-full items-center gap-4 mb-6">
              <div className="flex flex-col space-y-1.5 text-base">
                <FormField
                  control={form2.control}
                  name="confirmNewPassword"
                  render={({ field }) => (
                    <FormItem className="relative">
                      <FormLabel
                        className="text-xs tracking-wider"
                        dangerouslySetInnerHTML={{
                          __html: t("UpdatePassword.confirmPassword") + " *",
                        }}
                      />

                      <FormControl>
                        <Input
                          type={confrimPassword ? "text" : "password"}
                          placeholder={t("UpdatePassword.confirmPlaceHolder")}
                          {...field}
                          className="h-auto py-4 text-base pe-16 opacity-100"
                        />
                      </FormControl>
                      {confrimPassword ? (
                          <img
                            className="absolute top-[45px] right-[16px] w-[26px] h-[16px]"
                            onClick={() => setConfirmPassword(!confrimPassword)}
                            src={eye}
                            alt="No image"
                          />
                      ) : (
                          <img
                            className="absolute top-[41px] right-[15px] w-[29px] h-[22px]"
                            onClick={() => setConfirmPassword(!confrimPassword)}
                            src={eyeslash}
                            alt="No image"
                          />
                      )}
                      <FormMessage>{error}</FormMessage>
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <div className="grid w-full items-center gap-4 mb-6">
              <div className="flex flex-col space-y-1.5 text-base">
                <FormField
                  control={form2.control}
                  name="mobile"
                  render={({ field }) => (
                    <FormItem className="flex flex-row items-start space-x-3 space-y-0  shadow">
                      <FormControl>
                        <Checkbox
                          checked={field.value}
                          onCheckedChange={field.onChange}
                        />
                      </FormControl>
                      <div className="space-y-1 leading-none">
                        <FormLabel
                          dangerouslySetInnerHTML={{
                            __html: t("UpdatePassword.signOut"),
                          }}
                        />
                      </div>
                    </FormItem>
                  )}
                />
              </div>
            </div>

            <div className="flex justify-between grid-4 space-x-3">
              <span
                    onClick={()=>backFromDailyReminder()}
                    className="flex w-full h-auto py-3 cursor-pointer border rounded-[10px] justify-center  hover:bg-transparent bg-transparent font-normaltext-lg text-un-none"
                    dangerouslySetInnerHTML={{
                      __html: t("Common.cancel"),
                    }}
                  />

              <Button className="w-full h-auto py-3 text-base font-normal">
                <span
                  dangerouslySetInnerHTML={{ __html: t("UpdatePassword.save") }}
                />
              </Button>
            </div>
          </form>
        </Form>
      </div>
  );
};

export default withAlmToken(UpdatePassword);
